<template>
  <div class="interventions">
    <div class="header-intervention">
      <div class="intervention-type">
       Scan de l'ONU
      </div>
      <b-button-group size="sm" class="group">
        <b-button v-on:click="StartScan()" variant="outline-danger">Auto</b-button>
        <b-button v-on:click="CloseScan()" variant="outline-danger">Manuelle</b-button>
      </b-button-group>
    </div>
    <b-container class="account-content">
      <div id="interactive" class="viewport hide">
        <video class="video" autoplay="true" preload="auto" src="">
        </video>
      </div>
      <div id = "manuelle" class="manuel">
        <div class="label">
          <b>Saisie manuelle : </b><input id="scanne_manuel" class="header-info" placeholder="Scan du ONU" type="text" />
          <b-button class ="button" v-on:click="envoiScan()" variant="outline-default">Saisie manuelle</b-button>
        </div>
      </div>
      <div id = "result" class="manuel" hide>
        <div class="label">
          <b>Scan recuperer : </b><input id="scanner_input" class="header-info" placeholder="Scan du ONU" type="text" />
        </div>
      </div>
    </b-container>
  </div>
</template>

<script>
import moment from 'moment'
import Quagga from 'quagga' // ES6
moment.locale('fr')
export default {
  name: 'Account',
  data () {
    return {
      account: {}
    }
  },
  methods: {
    StartScan: function () {
      $('#interactive').removeClass('hide')
      $('#manuelle').addClass('hide')
      $('#result').addClass('hide')
      Quagga.init({
        inputStream: {
          type: 'LiveStream',
          constraints: {
            width: {min: 100},
            height: {min: 100},
            aspectRatio: {min: 1, max: 100},
            facingMode: 'environment' // or "user" f  or the front camera
          }
        },
        locator: {
          patchSize: 'medium',
          halfSample: true
        },
        numOfWorkers: (navigator.hardwareConcurrency ? navigator.hardwareConcurrency : 4),
        decoder: {
          readers: ['code_128_reader']
        },
        locate: true
      }, function (err) {
        if (err) {
          console.log(err)
          return
        }
        Quagga.start()
      })
      Quagga.onProcessed(function (result) {
        let drawingCtx = Quagga.canvas.ctx.overlay
        let drawingCanvas = Quagga.canvas.dom.overlay

        if (result) {
          if (result.boxes) {
            drawingCtx.clearRect(0, 0, parseInt(drawingCanvas.getAttribute('width')), parseInt(drawingCanvas.getAttribute('height')))
            result.boxes.filter(function (box) {
              return box !== result.box
            }).forEach(function (box) {
              Quagga.ImageDebug.drawPath(box, {x: 0, y: 1}, drawingCtx, {color: 'green', lineWidth: 2})
            })
          }

          if (result.box) {
            Quagga.ImageDebug.drawPath(result.box, {x: 0, y: 1}, drawingCtx, {color: '#00F', lineWidth: 2})
          }

          if (result.codeResult && result.codeResult.code) {
            Quagga.ImageDebug.drawPath(result.line, {x: 'x', y: 'y'}, drawingCtx, {color: 'red', lineWidth: 3})
          }
        }
      })
      Quagga.onDetected(function (result) {
        if (result.codeResult.code) {
          $('#scanner_input').val(result.codeResult.code)
          $('#interactive').addClass('hide')
          $('#manuelle').addClass('hide')
          $('#result').removeClass('hide')
          Quagga.stop()
        }
      })
    },
    CloseScan: function () {
      $('#interactive').addClass('hide')
      $('#manuelle').removeClass('hide')
      $('#result').addClass('hide')
      let scanhisto = $('#scanner_input').val()
      if (scanhisto) {
        $('#scanne_manuel').val(scanhisto)
      }
      if (Quagga) {
        Quagga.stop()
      }
    },
    envoiScan: function () {
      let scan = $('#scanne_manuel').val()
      $('#scanner_input').val(scan)
      $('#interactive').addClass('hide')
      $('#manuelle').addClass('hide')
      $('#result').removeClass('hide')
    }
  },
  mounted: function () {
  }
}
</script>
<style scoped>
  .hide{
    display: none;
  }
.video{
  padding-top: 125px;
  height: 100vh;
  width: 87vw;
  margin-bottom: 25px;
}
.manuel{
  padding-top: 125px;
  height: 100vh;
  width: 87vw;
  margin-bottom: 25px;
}
</style>



// WEBPACK FOOTER //
// src/components/Scan.vue